import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
      <header className="pl-header"><h1 className="pl-headline">YUIRAIL GEO</h1></header>
    );
  }
}

export default Header;